<template>
    <div>
        <a-card>
<!--    只有一个包组    -->
        <div v-if="packs">
            <h1 class="text-center color-main">竞价结果通知</h1>
            <div class="border p-5 color-black size3">
                <div class="size3">{{result.supplierName}} :</div>
                <div class="m-4 p-3">
                    <p class="p-2" v-if="packs.resultState === '1'">
                        {{result.projectName}} &nbsp;项目（项目编号：{{result.projectCode}}）
                        的网上竞价已结束，
                        贵单位在项目中成交 。<br>
                        成交{{ packs.offerType === '2' ? '折扣率' : packs.offerType === '3' ? '下浮率' : '金额' }}：
                         <template v-if="packs.offerType === '2' || packs.offerType === '3'">
                            {{ packs.successMoney && (packs.successMoney * 100)  }} %
                        </template>
                        <template v-else>
                            {{ packs.successMoney }} 元
                        </template>
                        <br>
                        请在2个工作日内下载页面下方的报价确认函模板并打印盖章后扫描上传，超期则采购人有权另行选定成交人。
                        <br>
                        感谢贵单位对本次竞价工作的支持！
                    </p>
                    <p class="p-2" v-if="packs.resultState === '2'">
                        {{result.projectName}} &nbsp;项目（项目编号：{{result.projectCode}}）
                        的网上竞价已结束，
                        贵单位未能在项目中成交。<br>
                        <span v-if="packs.bondMoney">
                            贵单位缴纳的投标保证金将在五个工作日内退还。
                        </span><br>
                        感谢贵单位对本次竞价工作的支持！
                    </p>
                    <p class="p-2" v-if="packs.resultState === '3'">
                        {{result.projectName}} &nbsp;项目（项目编号：{{result.projectCode}}）
                        的网上竞价已结束，
                        因报名供应商少于竞价文件中所规定的数量，该项目采购失败。<br>
                        <span v-if="packs.bondMoney">
                            贵单位缴纳的投标保证金将在五个工作日内退还。
                        </span><br>
                        感谢贵单位对本次竞价工作的支持！
                    </p>
                    <p class="p-2" v-if="packs.resultState === '4'">
                        {{result.projectName}} &nbsp;项目（项目编号：{{result.projectCode}}）
                        的网上竞价已结束，
                        因报价供应商少于竞价文件中所规定的数量，该项目采购失败。<br>
                        <span v-if="packs.bondMoney">
                            贵单位缴纳的投标保证金将在五个工作日内退还。
                        </span><br>
                        感谢贵单位对本次竞价工作的支持！
                    </p>
                </div>
                <div class="text-right">
                    广东志正招标有限公司
                </div>
                <div class="text-right">
                    {{result.resultDate}}
                </div>
            </div>
        </div>

        <!--    有多个包组    -->
        <div v-if="!packs && result && result.packsList.length > 1">
            <h1 class="text-center color-main">竞价结果通知</h1>
            <div class="border p-5 color-black size3">
                <div class="size3">{{result.supplierName}} :</div>
                <div class="p-5 ml-5">
                    <div class="mb-5">{{result.projectName}}项目（项目编号：{{result.projectCode}}）的网上竞价已结束，贵单位所参与包组的竞价结果如下：</div>
                    <div v-for="it in result.packsList">
                        <div class="mt-5">{{it.packsCodeName}}: {{it.packsName}}</div>
                        <div class="mt-2" v-if="it.resultState === '1'">贵单位成交，成交{{ it.offerType === '2' ? '折扣率' : it.offerType === '3' ? '下浮率' : '金额' }}：
                            <template v-if="it.offerType === '2' || it.offerType === '3'">
                                {{ (it.successMoney * 100).toFixed(2)  }} %
                            </template>
                            <template v-else>
                                {{ it.successMoney }} 元
                            </template>
                        </div>
                        <div class="mt-2" v-if="it.resultState === '2'">贵单位未能成交。</div>
                        <div class="mt-2" v-if="it.resultState === '3'">因报名供应商少于竞价文件中所规定的数量，包组采购失败</div>
                        <div class="mt-2" v-if="it.resultState === '4'">因报价供应商少于竞价文件中所规定的数量，包组采购失败</div>
                    </div>
                    <p class="mt-5">
                        如有成交，请在2个工作日内下载页面下方的报价确认函模板并打印盖章后扫描上传，超期则采购人有权另行选定成交人。
                        <br>
                        <span v-if="result.bondMoney">
                        非成交供应商所缴纳的投标保证金将在五个工作日内退还。
                        </span>
                    </p>
                    <p>感谢贵单位对本次竞价工作的支持！</p>
                </div>
                <div class="text-right">
                    广东志正招标有限公司
                </div>
                <div class="text-right">
                    {{result.resultDate}}
                </div>
            </div>


        </div>
            <div v-if="successPackList.length !== 0">
                <h2 class="mt-5">供应商成交报价确认函上传</h2>
                <div class="mb-5 color-red">
                    请下载<a style="text-decoration:underline !important;" href="javascript:;" @click="downTmp">《供应商成交报价确认函模板》</a>，打印盖章后上传。请在两个工作日内上传，否则采购人有权更换成交供应商。
                </div>
                <div class="mb-2">请扫描为PDF格式文件上传，文件大小不超过2MB</div>
                <upload-selector
                        :referId='getSuccessConfirmId'
                        ref="UploadSelector"
                        :max="1"
                        value="license"
                        configKey='supplier_success_confirm'
                        @uploadSuccess="uploadSelectorChange" />
            </div>

            <div class="text-center" style="margin: 40px 0" v-if="!result || result === null">
                <img style="margin: auto;width: 90px" src="../../img/empty4.png">
                <p class="size2 mt-3 color-ash">竞价结果未发布</p>
            </div>
        </a-card>
    </div>
</template>

<script>
    import UploadSelector from '@/components/selector/UploadSelector'
    import moment from "moment";
    import qs from 'qs'

    export default {
        props: {
            projectId: {
                type: String,
                required: true
            },
            currentSupplierId:{
                type: String,
                required: true
            },
            random: {
                type: String,
                default: '',
                required: false
            }
        },
        components: {
            UploadSelector
        },
        created() {
            this.initData();
        },
        computed: {
            getSuccessConfirmId(){
                return this.projectId + this.supplierId
            }
        },
        watch: {
            random: {
                immediate: false,
                handler(newValue, oldValue) {
                    if (newValue !== oldValue) {
                        // console.log("has listened data!")
                        this.initData();
                    }
                }
            }
        },
        name: "PreCase",
        data() {
            return {
                bondList: [],
                current: 1,
                pageList: [],
                supplierName: '张二狗有限公司',
                bondMoney: '1000',
                projectName: '电脑采购项目',
                projectCode: 'COMPUTER-CODE-ONE-0001',
                openDate: '2020-07-10',
                result:'',
                packs:'',
                state:'0',
                successPackList: '',
                successConfirmId: '', //业务ID 项目+供应商ID
                supplierId: this.currentSupplierId
            }
        },
        methods: {
            initData() {
                let  that = this
                this.$http.get('/api/v1/supplier/result/get_result.json?projectId=' + this.projectId).then(function (res) {
                    console.log(res.result)
                    if (res.code === 200) {
                        that.result = res.result
                        if (that.result) {
                            if(that.result.packsList.length === 1) {
                                that.packs = that.result.packsList[0]
                            }
                            that.successPackList = []
                            for (let i = 0; i < that.result.packsList.length; i++) {
                                var item = that.result.packsList[i]
                                if (item.resultState === '1') {
                                    that.successPackList.push(item)
                                }
                            }
                            that.supplierId = that.supplierId || that.result.supplierId
                        }else {
                            console.log("暂无结果,请耐心等待")
                        }
                    }
                })
            },
            downTmp() {
                let that = this
                this.$http.post('/api/v1/supplier/result/get_confirm_template.json', qs.stringify(this.initData), {
                    responseType: 'blob'
                }).then(res => {
                    let blob = new Blob([res], {
                        type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    })
                    if (window.navigator.msSaveOrOpenBlob) {
                        var fileName = '.xls'
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        let elink = document.createElement('a')
                        elink.download = '成交报价确认函.docx'
                        elink.style.display = 'none'
                        elink.href = URL.createObjectURL(blob)
                        document.body.appendChild(elink)
                        elink.click()
                        document.body.removeChild(elink)
                    }
                }).catch(err => {
                    console.warn(err)
                })
            },


            //supplierName
            uploadSelectorChange(fileLength){
                let that=this;

                if(fileLength){
                     const user = this.$ls.get('user');
                    //console.log(111);
                    if(this.result&&this.result.projectName&&user.supplierName){
                        let title="项目消息";
                        let content=user.supplierName+"已上传了"+this.result.projectName+"的《成交报价确认函》，请注意查看。";
                        this.$http.get('/api/v1/supplier/bid/send_msg_in_project.json?id='+this.projectId+'&title='+title+'&content='+content).then(function (res) {

                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
a{
    text-decoration: underline;
}
    /deep/ .file_list{
        background: #f7f7f7;
        margin-top: 12px;
        padding: 12px 16px;
        border-bottom: none;
    }
</style>
